export const CODE_LABELS = {
  btl: "BTL",
  "complex-btl": "Complex BTL",
  if: "Invoice Finance",
  af: "AF",
  bridging: "Bridging",
  sc: "Semi-Commercial (SC)",
  c: "Commercial",
};

export const codeToLabel = (code) => CODE_LABELS[code] || code?.toUpperCase();
export const shortLabel = (label) => (label || "").replace(/\(.*?\)/g, "").trim();

/** BTL supports manual entry and CSV upload. */
export const isManualEntryProduct = (code) => code === "btl";

/** Product types that only support CSV/XLSX bulk upload (no manual entry). */
export const isCsvOnlyProduct = (code) => code === "if";
